// ADV-P0K — reusable compact chart-launch button. Drops next to any symbol on any page
// and opens the platform chart via the shared router. Preserves sibling actions
// (stopPropagation). Renders nothing for non-chartable (FX) symbols.
import React from 'react';
import { LineChart } from 'lucide-react';
import { openSymbolChart, isChartableSymbol } from '../lib/symbolChart';

export default function SymbolChartButton({ symbol, assetClass, className }: { symbol: string; assetClass?: string; className?: string }) {
  const sym = (symbol || '').trim().toUpperCase();
  if (!isChartableSymbol(sym, assetClass)) return null;
  return (
    <button
      type="button"
      data-testid={'symbol-chart-open'}
      data-symbol={sym}
      title={'Open ' + sym + ' chart'}
      onClick={(e) => { e.stopPropagation(); openSymbolChart(sym, { assetClass }); }}
      className={className || 'inline-flex items-center justify-center h-5 w-5 rounded border border-[var(--card-border)] text-[var(--muted-text)] hover:text-[var(--app-text)] hover:bg-[var(--input-bg)]'}
    >
      <LineChart size={11} />
    </button>
  );
}
